import React, { useState } from 'react';
import Modal from 'react-modal';
import { FaYoutube } from 'react-icons/fa';
import '../css/Button.css'
import '../css/Video.css'

Modal.setAppElement('#root');

const VideoThumb = ({ videoUrl }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);

    return (
        <div>

            <button className='video-modal-enter' onClick={openModal}>
                <img src="thumbVideo.jpg" alt="Vimeo vídeo" className='imgThumb' />  <FaYoutube className='icon-thumb' />
            </button>


            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Vídeo Modal"
                className="modal"
            >
                <button className='modal-exit' onClick={closeModal}> Voltar</button>
                <div className='video'>
                    <iframe
                        width="560"
                        height="315"
                        src={videoUrl}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                    ></iframe>
                </div>
            </Modal>
        </div>
    );
};

export default VideoThumb;